// src/components/CardGrid/CardGrid.jsx
import React, { useState, useMemo, useRef, useEffect } from 'react';
import '../AboutUs/CardSlider/cardSlider.css';
import './blog.css';
import { Link } from 'react-router-dom';
import Banner from '../../Layout/Banner/Banner';
import { FaArrowRight } from "react-icons/fa6";
import Pagination from '../../Elements/Pagination/Pagination';
import { allCategoriesBlog, cardsBlogs } from '../../../json/sections/blog/cards';
import CityWatter from '../../Layout/cityWatter/cityWatter';
import { dataCityWatter } from '../../../json/layout/cityWatter';

export default function Blog() {
    // 1) Estado para categoría y paginación
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);

    // ref para la rejilla de cards
    const gridRef = useRef(null);

    // 2) Filtrar cards según categoría
    const filtered = useMemo(() => {
        return selectedCategory === 'All'
            ? cardsBlogs
            : cardsBlogs.filter(c => c.category === selectedCategory);
    }, [selectedCategory]);

    // 3) Paginación de 8 cards por página
    const itemsPerPage = 8;
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const pageStart = (currentPage - 1) * itemsPerPage;
    const visibleCards = filtered.slice(pageStart, pageStart + itemsPerPage);

    // 4) Cuando cambie la página, desplazarse al inicio de la rejilla
    useEffect(() => {
        if (gridRef.current) {
            gridRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [currentPage]);

    // 5) Header fijo
    const smallTitle = 'STAY UPDATED';
    const mainTitle = 'Read our\nlatest posts'; // "\n" para salto de línea

    return (
        <>
            <Banner />
            <div className="container card-content-blog">
                {/* --- SECTION HEADER --- */}
                <div className="section-header line-height-clss">
                    <small className="section-header__small line-height-clss">{smallTitle}</small>
                    <h2 className="section-header__main line-height-clss">
                        {mainTitle.split('\n').map((line, i, arr) => (
                            <React.Fragment key={i}>
                                {line}
                                {i < arr.length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </h2>
                    <hr className="section-header__divider" />
                </div>
                {/* --- CATEGORY NAV --- */}
                <nav className="categories-blog">
                    {allCategoriesBlog.map(cat => (
                        <button
                            key={cat}
                            className={`category-button-blog ${selectedCategory === cat ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedCategory(cat);
                                setCurrentPage(1);
                            }}
                        >
                            {cat}
                        </button>
                    ))}
                </nav>
                {/* --- CARDS GRID --- */}
                <div className="row mt-4" ref={gridRef}>
                    {visibleCards.map((card, i) => (
                        <div key={i} className="col-12 col-sm-6 col-md-3 mb-4">
                            <div className="card-custom">
                                {i % 2 === 0 ? (
                                    <>
                                        <div
                                            className="img-card-service"
                                            style={{
                                                backgroundImage: `url(${card.img})`,
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundSize: 'cover',
                                                width: '100%',
                                                minHeight: '320px'
                                            }}
                                        />
                                        <div className="card-body">
                                            <h3>{card.title}</h3>
                                            <p className='casper-normal'>{card.text}</p>
                                            <Link to={card.ref} className="btn btn-primary">
                                                LEARN MORE <FaArrowRight className="card-arrow" />
                                            </Link>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="card-body">
                                            <h3>{card.title}</h3>
                                            <p className='casper-normal'>{card.text}</p>
                                            <Link to={card.ref} className="btn btn-primary">
                                                LEARN MORE <FaArrowRight className="card-arrow" />
                                            </Link>
                                        </div>
                                        <div
                                            className="img-card-service"
                                            style={{
                                                backgroundImage: `url(${card.img})`,
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundSize: 'cover',
                                                width: '100%',
                                                minHeight: '320px'
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {/* --- PAGINACIÓN --- */}
                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                )}
            </div>
             <CityWatter data={dataCityWatter} />
        </>
    );
}
